import { Component, computed, signal, Signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControlStatus, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatList, MatListItem, MatListItemMeta, MatListItemTitle } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { TranslocoDirective } from '@jsverse/transloco';
import { FidelityAvailablePages } from 'app/shared/components/fidelity-base-page/fidelity-base-page.types';
import { FidelityBasePageComponent } from '../../../../shared/components/fidelity-base-page/fidelity-base-page.component';
import { FidelityOverlayPageWrapperComponent } from '../../../../shared/components/fidelity-overlay-page-wrapper/fidelity-overlay-page-wrapper.component';
import { GenericPageLoadingStateComponent } from '../../../../shared/components/generic-page-loading-state/generic-page-loading-state.component';
import { LegalDocumentsService } from '../../../../shared/legal-documents/legal-documents.service';
import { LegalDocumentData } from '../../../../shared/legal-documents/legal-documents.types';
import { FidelityPersonalDataService } from '../../personal-data/personal-data.service';

@Component({
    selector: 'app-consents',
    imports: [
        FidelityOverlayPageWrapperComponent,
        TranslocoDirective,
        MatList,
        MatListItem,
        MatSlideToggle,
        MatListItemTitle,
        MatListItemMeta,
        MatButton,
        FormsModule,
        ReactiveFormsModule,
        MatDivider,
        MatProgressSpinner,
        GenericPageLoadingStateComponent,
    ],
    templateUrl: './consents-page.component.html',
    styleUrl: './consents-page.component.scss',
})
export class ConsentsPageComponent extends FidelityBasePageComponent {
    public availablePages: FidelityAvailablePages = {};
    consentForm: FormGroup;
    consentFormStatus: Signal<FormControlStatus | undefined>;
    legalDocuments = signal<LegalDocumentData[]>([]);
    protected disableCrudActions = this.personalDataService.disableCrudActions;

    protected fetchingData: Signal<boolean> = this.personalDataService.fetchingData;
    disableSave = computed<boolean>(() => {
        this.consentFormStatus();
        return this.consentForm.invalid || this.disableCrudActions();
    });

    constructor(
        private fb: FormBuilder,
        private personalDataService: FidelityPersonalDataService,
        private legalDocumentsService: LegalDocumentsService
    ) {
        super();

        this.consentForm = this.fb.group({
            consentMarketing: [false],
            consentProfiling: [false],
        });
        this.consentFormStatus = toSignal(this.consentForm.statusChanges);

        this.personalDataService
            .getPersonalData()
            .pipe(takeUntilDestroyed())
            .subscribe((res) => {
                this.consentForm.patchValue(res.result);
            });

        this.legalDocumentsService
            .getLegalDocumentsForCustomerOperations(this.translocoService.getActiveLang())
            .subscribe((res) => {
                this.legalDocuments.set(res.result);
            });
    }

    saveChanges() {
        const dto = this.consentForm.value;
        this.personalDataService
            .updateConsents(dto)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((_) => {
                this.notifyResult(this.translocoService.translate('fidelity-app.account.consent.notification-caption'));
                this.navBack();
            });
    }
}
